export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      {/* Background with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20amber%20and%20coral%20tones%2C%20soft%20geometric%20patterns%2C%20modern%20cinematic%20atmosphere%2C%20smooth%20textures%2C%20warm%20lighting%2C%20no%20text%2C%20clean%20composition%2C%20entertainment%20media%20vibe%2C%20dark%20bottom%20gradient%20for%20text%20contrast&width=1800&height=900&seq=hero-bg-nc-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-300 font-label whitespace-nowrap">
                高清流畅 · 即点即看
              </span>
            </div>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              嫩草视频
              <span className="block text-primary-400 mt-1">手机网页版高清观影平台</span>
            </h1>

            <p className="text-sm md:text-base text-background-200/90 font-label mt-5 leading-relaxed max-w-xl mx-auto lg:mx-0">
              嫩草视频手机网页版无需下载APP，聚合<strong className="text-primary-300 font-semibold">97视频</strong>、<strong className="text-primary-300 font-semibold">丝瓜视频</strong>、<strong className="text-primary-300 font-semibold">蓝莓视频</strong>、<strong className="text-primary-300 font-semibold">91在线视频</strong>等热门资源，电影电视剧资源丰富，高清流畅不卡顿，打开浏览器即可享受流畅观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-7">
              <div className="flex items-center gap-2 text-background-200/80 text-xs font-label">
                <i className="ri-eye-line text-primary-400"></i>
                <span>每日热片更新</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80 text-xs font-label">
                <i className="ri-smartphone-line text-primary-400"></i>
                <span>手机网页即开即看</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80 text-xs font-label">
                <i className="ri-shield-check-line text-primary-400"></i>
                <span>安全无广告弹窗</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#topics"
                className="w-full sm:w-auto px-7 py-3 rounded-full bg-primary-500 text-background-50 font-heading font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                立即探索热门
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-7 py-3 rounded-full border border-background-300/50 text-background-50 font-heading font-medium text-sm hover:bg-background-50/10 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                查看专题合集
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-3 bg-primary-500/15 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20smartphone%20floating%20in%20space%20displaying%20video%20streaming%20interface%20with%20movie%20thumbnails%2C%20warm%20coral%20and%20amber%20cinematic%20lighting%2C%20glossy%20screen%20reflection%2C%20clean%20dark%20background%2C%203D%20render%20style%2C%20premium%20product%20showcase%2C%20no%20visible%20brand%20logos&width=900&height=700&seq=hero-visual-nc-01&orientation=portrait"
                alt="嫩草视频手机网页版高清观影界面展示"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '4/3' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}